// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8912449e","590":"3aba9e63"}[chunkId] + ".chunk.js";
};